<div class="whitecleaner">
    <div class="line" style="background-color:white;">
        <div class="margin" style="margin-bottom:50px;">
            <app-sidebar [Menu]="Menu"></app-sidebar>
            <app-inhoud [MenuSwitch]="Menu"></app-inhoud>
        </div>
    </div>
</div>